import i18n from '../../i18n';

export const snConfig = {
  get labels() {
    return {
      part_ir: i18n.t('countryLabels.sn.partIr'),
      trimf: i18n.t('countryLabels.sn.trimf'),
    };
  },
  currency: "FCFA",
  taxSystem: "sn",
  allowedReports: [
    "Livre de paie",
    "Charges salariales",
    "Charges patronales",
    "VRS",
    "IPRES",
    "CSS",
    "ETAT 1024 (1)",
    "ETAT 1024 (2)",
    "DASMO",
    "Bilan social",
  ]
};